import React from 'react';
import {
  OnboardingWelcomeModal,
  SetupBrokerageWizardModal,
  OnboardingPreLaunchModal,
  UserSuggestedUpdateModal,
  FeedbackModal,
  AppointmentActionModal,
  ContextualChatModal,
  AddListingToTourModal,
} from 'modals';

export default () => (
  <>
    <AddListingToTourModal />
    <OnboardingWelcomeModal />
    <SetupBrokerageWizardModal />
    <OnboardingPreLaunchModal />
    <UserSuggestedUpdateModal />
    <FeedbackModal />
    <AppointmentActionModal />
    <ContextualChatModal />
  </>
);
